/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M904.2 456.5H568V120.3c0-33.6-28-56-56-56-33.6 0-56 28-56 56v336.2H119.7c-33.6 0-56 22.4-56 56s22.4 56 56 56h336.2v336.2c0 33.6 22.4 56 56 56s56-22.4 56-56V568.5h336.2c33.6 0 56-28 56-56 .1-33.6-27.9-56-55.9-56z" _fill="#0F0F0F"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/add.js